export default "__VITE_ASSET___tgUShpi__"